<template>
    <div class="order-card-mixed" @click="toDetail">
        <header>
            合并订单
            <img src="../assets/right-chevron.png" alt="more">
        </header>
        <section>
            <order-card v-for="order in viewData['order']"
                        class="order-card"
                        :is-merge="true"
                        :key="order['id']"
                        :view-data="order"/>
        </section>
        <footer class="bl">
            <span>实付： ¥</span>
            <span class="before-dot">{{price.beforeDot}}</span>
            <span class="after-dot">.{{price.afterDot}}</span>
        </footer>
        <footer class="btn-foot" v-if="actionBtnShow">
            <button @click.prevent.stop="deleteMergeOrder">删除订单</button>
        </footer>
    </div>
</template>

<script>
import OrderCard from "./OrderCard.vue";

export default {
    name: 'OrderCardMixed',
    components: {OrderCard},
    props: {
        viewData: {
            type: Object,
            required: true,
        },
    },

    computed: {
        price() {
            const price = this.viewData['order_price'] - this.viewData['order_discount'];
            const afterDot = price % 100;
            return {
            beforeDot: parseInt(price / 100),
            afterDot: afterDot < 10 ? `0${afterDot}` : afterDot
            }
        },
        actionBtnShow() {
            let list = this.viewData.order;
            if (list.length === 0) return false;
            for (let idx = 0; idx < list.length; idx += 1) {
                if (!(list[idx].state==='refunded' || list[idx].state==='completed')) {
                    return false;
                }
            }
            return true;
        },
    },

    mounted() {
        console.log(this.viewData);
    },

    methods: {
        deleteMergeOrder() {
            this.$emit('deleteMergeOrder', this.viewData.id);
        },
        toDetail() {
            this.$router.push({
                name: 'mixOrderDetail',
                params: {
                    viewData: this.viewData
                },
            })
        },
    },
}
</script>


<style lang="scss" scoped>
 .order-card-mixed {
        background-color: #fff;
        border-radius: 0.05rem;
        margin-bottom: 0.16rem;

        header {
            display: flex;
            align-items: center;
            font-size: 0.14rem;
            padding: 0.12rem;
            border-bottom: 1px solid rgba(151, 151, 151, 0.15);

            img {
                width: 0.08rem;
                height: 0.13rem;
                margin-left: 0.08rem;
            }
        }

        section {
            padding: 0.16rem 0.16rem 0;

            .order-card {
                & + .order-card {
                    margin-top: 0.28rem;
                }
            }
        }

        footer {
            display: flex;
            justify-content: flex-end;
            align-items: baseline;
            height: 0.45rem;
            padding: 0.18rem 0.16rem 0;
            font-size: 0.12rem;

            .before-dot {
                font-size: 0.18rem;
                margin-left:.04rem;
            }

            button {
                border: 1px solid #4455E4;
                border-radius: 2px;
                padding: 0.05rem 0.14rem;
                color: #4455E4;
                font-size: 0.12rem;
                opacity: 0.6;


                & + button {
                    margin-left: 0.12rem;
                    opacity: 1;
                }
            }

            &.btn-foot {
                padding: 0.09rem 0.16rem;
            }
        }
    }
    .bl{
      border-top:0.5px solid rgba(151, 151, 151, 0.15);
      margin-top: .13rem;
      padding-top:.14rem!important;
    }
</style>